import { Typography } from "@mui/material"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { ConfirmModal } from "../../../../../../../shared/components/dialogs/ConfirmModal"

type Props = Readonly<{
    open: boolean
    onConfirm: () => void
    onClose: () => void
}>

export function ClearWeekConfirmDialog({ open, onConfirm, onClose }: Props) {
    return (
        <LocalizedStrict id="merchant-week-menu-clear-week-dialog" attrs={{ title: true, buttonLabelSubmit: true }}>
            <ConfirmModal
                open={open}
                onClose={onClose}
                handleClick={onConfirm}
                title="Clear week"
                message={
                    <LocalizedStrict id="merchant-week-menu-clear-week-dialog-message">
                        <Typography variant="body1">
                            This removes all dishes entered for this week. The action cannot be undone.
                        </Typography>
                    </LocalizedStrict>
                }
                buttonLabelSubmit="Clear"
            />
        </LocalizedStrict>
    )
}
